(function () {
  // --- CONFIG ---
  // Add as many triggers as you want here
  // Each trigger param maps to an array of items to add.
  const TRIGGERS = {
    // existing link: https://yourstore.com/whatever?Viptote
    FreeShroom: [
      { id: '48135081722071', quantity: 1 }
    ],

    // new link: https://yourstore.com/whatever?Viptote2
    WelcomeBack: [
      { id: '46396002861271', quantity: 1 },
      { id: '48255169331415', quantity: 1 }
    ]
  };

  // --- UTILS ---

  function getSessionStorage() {
    try {
      return window.sessionStorage || null;
    } catch (e) {
      return null;
    }
  }

  function getActiveTrigger() {
    const search = window.location.search;
    if (!search) return null;

    // Prefer URLSearchParams when available
    if (typeof URLSearchParams !== 'undefined') {
      const params = new URLSearchParams(search);
      // Find the first trigger that exists in the URL
      for (const key in TRIGGERS) {
        if (params.has(key)) return key;
      }
      return null;
    }

    // Fallback: manual parse (also covers raw `?Viptote` etc.)
    const keys = search
      .slice(1)
      .split('&')
      .map(function (pair) { return pair.split('=')[0]; });

    for (let i = 0; i < keys.length; i++) {
      if (TRIGGERS[keys[i]]) return keys[i];
    }
    return null;
  }

  function storageKeyFor(triggerParam) {
    return 'autoAdd_' + triggerParam;
  }

  function alreadyProcessed(triggerParam) {
    const storage = getSessionStorage();
    const key = storageKeyFor(triggerParam);
    return storage ? storage.getItem(key) === '1' : false;
  }

  function markProcessed(triggerParam) {
    const storage = getSessionStorage();
    if (!storage) return;

    const key = storageKeyFor(triggerParam);
    try {
      storage.setItem(key, '1');
    } catch (e) {
      // fail silently
    }
  }

  function addItemsToCart(triggerParam) {
    if (alreadyProcessed(triggerParam)) return;

    const items = TRIGGERS[triggerParam];
    if (!items || !items.length) return;

    // If only one item, keep the old payload shape (id/quantity)
    const body =
      items.length === 1
        ? { id: items[0].id, quantity: items[0].quantity || 1 }
        : { items: items.map(function (it) { return ({ id: it.id, quantity: it.quantity || 1 }); }) };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        markProcessed(triggerParam);
        console.log('Added to cart via', triggerParam, data);

        // Optional:
        // window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  // --- INIT ---
  const activeTrigger = getActiveTrigger();
  if (!activeTrigger) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      addItemsToCart(activeTrigger);
    }, { once: true });
  } else {
    addItemsToCart(activeTrigger);
  }
})();
